import { ExternalLink, TextReg } from '@sunrise-ui/primitives';
import React from 'react';

export function SmsConsentText() {
  return (
    <TextReg style={{ flex: 1 }}>
      I agree to receive SMS messages from Communiful, like event updates and
      offers. Msg & data rates may apply. Message frequency varies. Reply STOP
      to unsubscribe, HELP for help. See our{' '}
      <ExternalLink href="https://www.joincommuniful.com/terms">
        Terms
      </ExternalLink>{' '}
      &{' '}
      <ExternalLink href="https://www.joincommuniful.com/privacy-policy">
        Privacy
      </ExternalLink>
      .
    </TextReg>
  );
}
